import { render } from "./GalleryCarousel.vue?vue&type=template&id=4074f42a&scoped=true"
import script from "./GalleryCarousel.vue?vue&type=script&lang=js"
export * from "./GalleryCarousel.vue?vue&type=script&lang=js"

import "./GalleryCarousel.vue?vue&type=style&index=0&id=4074f42a&lang=scss&scoped=true"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4074f42a"]])

export default __exports__